export const DonutChart = {
  mounted() {
    this.segments = this.el.querySelectorAll("[data-segment]");
    this.legendItems = this.el.querySelectorAll("[data-legend]");
    this.centerValue = this.el.querySelector("[data-center-value]");
    this.centerLabel = this.el.querySelector("[data-center-label]");
    this.originalValue = this.centerValue ? this.centerValue.textContent : null;
    this.originalLabel = this.centerLabel ? this.centerLabel.textContent : null;

    const showSegmentValue = (index) => {
      const seg = this.el.querySelector(`[data-segment="${index}"]`);
      if (!seg) return;
      if (this.centerValue && seg.dataset.value) {
        this.centerValue.textContent = seg.dataset.value;
      }
      if (this.centerLabel && seg.dataset.label) {
        this.centerLabel.textContent = seg.dataset.label;
      }
    };

    const restoreCenter = () => {
      if (this.centerValue && this.originalValue != null) {
        this.centerValue.textContent = this.originalValue;
      }
      if (this.centerLabel && this.originalLabel != null) {
        this.centerLabel.textContent = this.originalLabel;
      }
    };

    const addHover = (index) => {
      this.segments.forEach((seg) => {
        if (seg.dataset.segment !== index) {
          seg.style.opacity = "0.25";
          seg.style.filter = "saturate(0.2)";
        } else {
          seg.style.opacity = "1";
          seg.style.filter = "none";
        }
      });
      this.legendItems.forEach((item) => {
        if (item.dataset.legend !== index) {
          item.style.opacity = "0.4";
        } else {
          item.style.opacity = "1";
        }
      });
      showSegmentValue(index);
    };

    const removeHover = () => {
      this.segments.forEach((seg) => {
        seg.style.opacity = "1";
        seg.style.filter = "none";
      });
      this.legendItems.forEach((item) => {
        item.style.opacity = "1";
      });
      restoreCenter();
    };

    this.segments.forEach((seg) => {
      seg.addEventListener("mouseenter", () => addHover(seg.dataset.segment));
      seg.addEventListener("mouseleave", removeHover);
    });

    this.legendItems.forEach((item) => {
      item.addEventListener("mouseenter", () => addHover(item.dataset.legend));
      item.addEventListener("mouseleave", removeHover);
    });
  },
};
